<template>
  <f-form-group
    v-if="field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :label="field_label"
    :hide-label="hideLabel"
    :horizontal="horizontal"
    v-b-tooltip="tooltip"
  >
    <b-input-group size="lg" prepend="$">
      <b-form-input
        :disabled="is_disabled"
        :label="field_label"
        :value="field_value"
        @input="on_input_number"
        prepend-icon="attach_money"
        step="0.01"
        type="number"
        v-bind="field.params"
      ></b-form-input>
    </b-input-group>
  </f-form-group>
</template>

<script>
import FormWidgetMixin from "../FormWidgetMixin.js";
import FFormGroup from "../FFormGroup.vue";

export default {
  name: "MoneyWidget",
  components: { FFormGroup },
  mixins: [FormWidgetMixin],
};
</script>
